<div class="top-header">
    <div class="top-header-logo">
        <a class="fc-logo" href="https://www.fidelitycharitable.org/">
            <img
                id="header_FC_logo"
                src="assets/images/FC_Logo_Horizontal.svg"
                alt="Fidelity Charitable"
                 />
        </a>
    </div>
</div>
